import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BaseUnsubscribeComponent } from './base-unsubscribe/base-unsubscribe.component';
import { IframeModalComponent } from './iframe-modal/iframe-modal.component';
import { PdfModalComponent } from './pdf-modal/pdf-modal.component';
import { AutoNotifyBaseComponent } from './auto-notify-base/auto-notify-base.component';
import { HorseLabelComponent } from './horse-label/horse-label.component';

@NgModule({
  declarations: [
    HorseLabelComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    BaseUnsubscribeComponent,
    PdfModalComponent,
    IframeModalComponent,
    PdfViewerModule,
  ],
  exports: [BaseUnsubscribeComponent, PdfModalComponent, IframeModalComponent, HorseLabelComponent],
})
export class SharedComponentsModule {}
